import { apiRequest, apiUpload } from './client'
import type { Attachment } from './types'

export const attachmentsApi = {
  listForTask: (taskId: string) => apiRequest<{ data: Attachment[] }>(`/tasks/${taskId}/attachments`),
  uploadForTask: (taskId: string, file: File) => apiUpload<{ data: Attachment }>(`/tasks/${taskId}/attachments`, file),

  listForDocument: (documentId: string) => apiRequest<{ data: Attachment[] }>(`/documentation/${documentId}/attachments`),
  uploadForDocument: (documentId: string, file: File) => apiUpload<{ data: Attachment }>(`/documentation/${documentId}/attachments`, file),

  remove: (attachmentId: string) => apiRequest<{ data: { success: boolean } }>(`/attachments/${attachmentId}`, { method: 'DELETE' }),

  downloadUrl: (attachmentId: string) => `/api/v1/attachments/${attachmentId}/download`,
}
